<template>
  <div>
    <template v-if="permissionDetail">
      <topsearch :title="permissionDetail.name" />
      <Datatable
        :table="table"
        :permissions="permissionDetail"
        :tablename="permissionDetail.name"
        detailurl="/detail/"
      />
    </template>
  </div>
</template>

<script>
import Datatable from "../components/Datatable/Table";

export default {
  name: "list",
  components: { Datatable },
  data() {
    return {
      table: null,
      permissionMap: [],
      tableInfo: {}
    };
  },
  computed: {
    permissionDetail() {
      return this.$root.cache.permissions.find(e => e.table == this.table);
    }
  },
  watch: {
    $route(to, from) {
      this.table = this.$route.params.table;
    }
  },
  created() {
    this.table = this.$route.params.table;
  }
};
</script>
